import { IGlobalConfig } from "../appRoutesConfig";
import { pageRoutes } from "../";
import React from "react";

const healthRoutesConfig: IGlobalConfig = [
  {
    auth: [],
    exact: true,
    component: React.lazy(() => import("./get")),
    title: "FTS | Not Found",
    path: pageRoutes.HEALTH_GET,
  },
];

export { healthRoutesConfig };
